module.exports = __webpack_public_path__ + "static/media/YF75_03.c6b178e6.jpg";